import React from 'react'

// --- merged from src/Logo.tsx ---
export function Logo({
  className,
  width = 120,
  height = 40,
  'data-id': dataId,
}: {
  className?: string
  width?: number
  height?: number
  'data-id'?: string
}) {
  return (
    <img
      src="https://cdn.magicpatterns.com/design-systems/ds-bf50d2ed-a1c3-4aac-be2b-c8a50c6202d6/logos/5f4f566c-45fc-49bb-9897-b21d9ed7f009.png"
      alt="Logo"
      className={className}
      style={{
        width,
        height,
        objectFit: 'contain',
      }}
      data-id={dataId}
    />
  )
}
